import { ns } from '@leverege/i18n';
const {
  t
} = ns('molten.imagine.forms.editors.ImagineImageEditor');
function checkFileSize(file, size) {
  if (file?.size > size) {
    return t('fileTooBig', {
      fileSize: file.size,
      maxSize: getBytesSize(size)
    });
  }
  return true;
}
function getBytesSize(size) {
  if (size > 1000 * 1000) {
    return t('bytes', {
      size: Math.round(size / (1000 * 1000) * 100) / 100,
      unit: 'MB'
    });
  }
  if (size > 1000) {
    return t('bytes', {
      size: Math.round(size / 1000 * 100) / 100,
      unit: 'KB'
    });
  }
  return t('bytes', {
    size,
    unit: 'bytes'
  });
}
export default {
  checkFileSize,
  getBytesSize
};